import { useParams } from "react-router";

import { useQuery } from "@tanstack/react-query";

import { dutySchedulesApi } from "@/api";
import { QueryKey } from "@/query/Query";
import { DutyScheduleByIdParams } from "@/router/DutyScheduleRoutes";

/**
 * The duty schedule behind the current route, with its calculated result. Everything it returns is the
 * snapshot taken when the calculation ran, so it never reflects later configuration changes.
 */
export function useDutyScheduleDetail() {
  const { id } = useParams<DutyScheduleByIdParams>();

  const { data: dutySchedule, isLoading } = useQuery({
    queryKey: [QueryKey.DutyScheduleDetail, id],
    // The route cannot match without an id; the fallback only satisfies the type.
    queryFn: () => dutySchedulesApi.getDutyScheduleById({ id: id ?? "" }),
    enabled: id != null,
  });

  return { id, dutySchedule, isLoading };
}
